var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28601 11.4651C0.601006 11.7281 0.115006 12.3441 0.0180061 13.0711C-0.0779939 13.7991 0.231006 14.5201 0.824006 14.9511L7.31601 19.6751L30.374 1.53407L9.98501 21.6211L18.86 28.0791C19.424 28.4891 20.153 28.6121 20.824 28.4091C21.494 28.2051 22.028 27.6961 22.268 27.0411L31.762 1.05507C31.858 0.791067 31.79 0.496067 31.59 0.299067C31.391 0.102067 31.096 0.0400666 30.832 0.141067L1.28601 11.4651Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77393 21.2461L5.82893 21.5471L7.08893 28.4361C7.18293 28.9481 7.52493 29.3771 8.00093 29.5841C8.47693 29.7901 9.02593 29.7461 9.46193 29.4651C11.2169 28.3331 13.5089 26.8311 13.4469 26.7431L5.77393 21.2461Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.517ae91c870df630261feab882956eec.svg";
export { ForwardRef as ReactComponent };